<template>
    <div ref="interactive_container" class="interactive-buttons" :class="{ 'fixed': scrollOverInteractive }">
        <a href="https://survey.alchemer.eu/s3/90523754/izziblog-predlagaj" target="_blank"   rel="noopener"><img src="/images/blog/predlagaj-temo.png" alt="predlagaj temo" ></a>
        <a href="https://survey.alchemer.eu/s3/90523756/izziblog-sodeluj"   target="_blank"   rel="noopener"><img src="/images/blog/sodeluj-z-nami.png" alt="sodeluj z nami"></a>
        <a href="https://survey.alchemer.eu/s3/90523755/izziblog-vprasaj"   target="_blank"   rel="noopener"><img src="/images/blog/vprasaj-strokovnjaka.png" alt="vprasaj strokovnjaka"></a>
        <a @click="openPoup" rel="noopener"><img src="/images/blog/prijava-na-novice.png" alt="prijava na novice"></a>
    </div>
</template>

<script>

export default {
    props: ["singleBlog"],
    data() {
        return {
            scrollOverInteractive: false
        };
    },
    mounted() {
        this.buttonsContainerCoord = (this.$refs.interactive_container.offsetTop || 0)  -50;
        this.buttonsContainerHeight = 700; // default, init value

        // za pravilen element height je treba počakat na load sorodnih vsebin, komentarjev in slik
        if (this.singleBlog) {
            window.addEventListener("scroll", this.onSingleScroll, { passive: true });
            setTimeout(() => {
                this.sorodneVsebineCoordinates = document.getElementById(this.scrollToElement).offsetTop;
                this.buttonsContainerHeight = this.$refs.interactive_container.offsetHeight;
                this.scrollToElement = document.documentElement.clientWidth < 992 ? "novice" : "sorodne-vsebine";
                this.scrollToElement = document.getElementById(this.scrollToElement) == null ? "ocena" : this.scrollToElement;
                 // na novice se zanašamo, da je iframe vnešen v wh skupaj z id-jem (sorodne-vsebine bodo vedno prisotne, t.j. != null)
                window.addEventListener("resize", _.debounce(this.resizeOnSingleScroll, 250));
            }, 2000);
        } else {
            window.addEventListener("scroll", this.onScroll, { passive: true });
            setTimeout(() => {
                this.footerCoord = document.getElementsByTagName("footer")[0].offsetTop;
                this.buttonsContainerHeight = this.$refs.interactive_container.clientHeight;
                window.addEventListener("resize", _.debounce(this.resizeOnScroll, 250));
            }, 1000); // 5000 for debugging - depends how fast pc is
        }
    },
    beforeDestroy() {
        if (this.singleBlog) {
            window.removeEventListener("scroll", this.onSingleScroll, { passive: true });
            window.removeEventListener("resize", _.debounce(this.resizeOnSingleScroll));
        } else {
            window.removeEventListener("scroll", this.onScroll, { passive: true });
            window.removeEventListener("resize", _.debounce(this.resizeOnScroll));
        }
    },
    methods: {
        openPoup(e) {
            e.preventDefault();
            $('#prijava-na-novice-popup').trigger('click')
        },
        resizeOnSingleScroll() {
            this.sorodneVsebineCoordinates = document.getElementById(this.scrollToElement).offsetTop;
            this.buttonsContainerHeight = this.$refs.interactive_container.offsetHeight;
            this.scrollToElement = document.documentElement.clientWidth < 992 ? "novice" : "sorodne-vsebine";
            this.scrollToElement = document.getElementById(this.scrollToElement) == null ? "ocena" : this.scrollToElement;
        },
        resizeOnScroll() {
            this.footerCoord = document.getElementsByTagName("footer")[0].offsetTop;
            this.buttonsContainerHeight = this.$refs.interactive_container.clientHeight;
        },
        onSingleScroll() {
            const scrollTop = document.documentElement.scrollTop;
            const beforeSorodneVsebine = scrollTop < this.sorodneVsebineCoordinates - this.buttonsContainerHeight - 100;
            const isActiveButtonScrolling = scrollTop > this.buttonsContainerCoord;

            // za pravilen element height je treba počakat na load sorodnih vsebin
            if (this.sorodneVsebineCoordinates == null || this.buttonsContainerHeight == null ) {
                this.scrollToElement = document.documentElement.clientWidth < 992 ? "novice" : "sorodne-vsebine";
                this.scrollToElement = document.getElementById(this.scrollToElement) == null ? "ocena" : this.scrollToElement;
                 // na novice se zanašamo, da je iframe vnešen v wh skupaj z id-jem (sorodne-vsebine bodo vedno prisotne, t.j. != null)
                this.sorodneVsebineCoordinates = document.getElementById(this.scrollToElement).offsetTop;
                this.buttonsContainerHeight = this.$refs.interactive_container.offsetHeight;
            }
            // buttons between 0 and sorodne vsebine - active (position: fixed)
            if (isActiveButtonScrolling && beforeSorodneVsebine) {
                if (!this.scrollOverInteractive) {
                    this.scrollOverInteractive = true;
                    this.$refs.interactive_container.style.removeProperty("top");
                }
            // buttons on sorodne vsebine - inactive
            } else if (isActiveButtonScrolling  && !beforeSorodneVsebine) {
                if (this.scrollOverInteractive) {
                    this.scrollOverInteractive = false;
                    this.$refs.interactive_container.style.top = (this.sorodneVsebineCoordinates - this.buttonsContainerHeight - 100) + "px";
                }
            // buttons on hero - inactive
            } else {
                if (this.scrollOverInteractive) {
                    this.scrollOverInteractive = false;
                    this.$refs.interactive_container.style.removeProperty("top");
                }
            }
        },
        onScroll() {
            const scrolledFromTop = document.documentElement.scrollTop;
            const beforeFooterBorder = (scrolledFromTop + this.buttonsContainerHeight + 50) < this.footerCoord;
            const isActiveButtonScrolling = scrolledFromTop > this.buttonsContainerCoord;

            // buttons between 0 and footer - btns alongside scrolling
            if (isActiveButtonScrolling && beforeFooterBorder) {
                if (!this.scrollOverInteractive) {
                    this.scrollOverInteractive = true;
                    this.$refs.interactive_container.style.removeProperty("top");
                }
            // buttons on footer - inactive
            } else if (isActiveButtonScrolling && !beforeFooterBorder) {
                if (this.scrollOverInteractive) {
                    this.scrollOverInteractive = false;
                    this.$refs.interactive_container.style.top = (this.footerCoord - this.buttonsContainerHeight - 150) + "px";
                }
            // buttons on hero - initial value
            } else {
                if (this.scrollOverInteractive) {
                    this.scrollOverInteractive = false;
                    this.$refs.interactive_container.style.removeProperty("top");
                }
            }
        }
    }
}
</script>
